/**
 * focalCrop.js — pure geometry for the non-destructive focal-point crop control
 * (EW-003 u1b FocalZoomControl). No React, no DOM: takes plain numbers/rects so
 * the math is unit-tested in isolation.
 */

const clamp01 = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0.5;
  return Math.min(1, Math.max(0, x));
};

/**
 * Convert a pointer's client (x,y) into a normalised focal point (0..1) inside a
 * stage rect. Points outside the rect clamp to the edges.
 *
 * @param {number} clientX pointer clientX
 * @param {number} clientY pointer clientY
 * @param {{left:number,top:number,width:number,height:number}} rect stage rect
 * @returns {{x:number,y:number}} normalised focal point (0..1)
 */
export const pointFromClientXY = (clientX, clientY, rect) => {
  const r = rect || {};
  const w = Number(r.width) || 1;
  const h = Number(r.height) || 1;
  return {
    x: clamp01((Number(clientX) - (Number(r.left) || 0)) / w),
    y: clamp01((Number(clientY) - (Number(r.top) || 0)) / h),
  };
};

/**
 * A normalised focal point as a CSS `object-position` / `background-position`
 * string (percentages). 0.5,0.5 → "50% 50%".
 *
 * @param {number} x 0..1
 * @param {number} y 0..1
 * @returns {string} e.g. "20% 80%"
 */
export const previewObjectPosition = (x, y) =>
  `${Math.round(clamp01(x) * 100)}% ${Math.round(clamp01(y) * 100)}%`;

const focalCrop = { pointFromClientXY, previewObjectPosition };
export default focalCrop;
